import { render } from "./TvmStructuredSuggestions.vue?vue&type=template&id=00da608c&scoped=true"
import script from "./TvmStructuredSuggestions.vue?vue&type=script&lang=js"
export * from "./TvmStructuredSuggestions.vue?vue&type=script&lang=js"

import "./TvmStructuredSuggestions.vue?vue&type=style&index=0&id=00da608c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00da608c"]])

export default __exports__